import type { SwapSlice, } from "../slice";
import type { EvaluatedSwap, } from "../types";



/**
 * Evaluates whether a swap is valid based on state of the swap slice.
 * @remark normally included in the final state update.
 * 
 * @param {SwapSlice} swap - The swap state containing the input amount
 * @returns {EvaluatedSwap} The evaluation result - "OK" if valid, "TO_LOW" if amount is too low
 */
export const evaluateSwap = (
	swap: SwapSlice,
): EvaluatedSwap => {

	const {
		mode,
		amountIn,
		amountOut,
		minimumSwapBrkt,
	} = swap;

  if(Number(amountIn) === 0) return "OK";

	// if(Number(amountIn) < 0.01) return "minimum deposit not met";
  // if(Number(amountIn) < minimumSwapEth) return `minimum ${mode === "BUY" ? "purchase amount" : "redeemable amount"} is ${minimumSwapEth.toFixed(5)} ${tokenIn.label}`;

	switch(mode) {
		case "BUY":
			if(Number(amountOut) < minimumSwapBrkt) return `minimum purchase amount is ${minimumSwapBrkt.toFixed(5)} brktETH`;
			break;
		case "REDEEM":
			if(Number(amountIn) < minimumSwapBrkt) return `minimum redeemable amount is ${minimumSwapBrkt.toFixed(5)} brktETH`;
			break;
		default:
			throw new Error(`@bracket/platform::evaluateSwap::evaluateSwap failed to evaluate swap for unknown mode "${mode}"`);
	}


  return "OK";

}
